import { If } from "shared/components/control-statements";
import styles from "../../../styles/beneficios/BenefitCard.module.scss";
import { Button } from "../../components/Button";
import { Icon } from "../../components/core/Icon";
import { Dates } from "../../utils/Dates";
import { Environment } from "shared/core/Environment";

const st = (className) => styles[className];

export const BenefitArchivedCard = ({
  benefit,
  onOpenQrCode,
  onOpenDetails,
  onOpenOptions,
}) => {
  return (
    <div className={st("benefit-card")}>
      <div className={st("header")}>
        <div className="d-flex align-center">
          <div className={st("icon-gift")}>
            <i className="fal fa-gift" />
          </div>
          <div className="d-flex align-center">
            <span className={st("code")}>{benefit.code}</span>
            <If cond={Environment.id !== 51}>
              <span className={st("code")}>&nbsp;&nbsp;-</span>
              <span className={st("pin")}>{(benefit.pin || "").toUpperCase()}</span>
            </If>
          </div>
        </div>

        <div className="d-flex gap-5">
          <Button
            design="default-icon-mini-4"
            onClick={() => onOpenDetails && onOpenDetails(benefit)}
          >
            <i className="fal fa-chart-waterfall" />
          </Button>
          <Button
            design="default-icon-mini-4"
            onClick={() => onOpenQrCode && onOpenQrCode(benefit)}
          >
            <i className="fal fa-qrcode" />
          </Button>
        </div>
      </div>

      <div className={st("content")}>
        <div className={st("infos")}>
          <div className={st("info")}>
            <p>Data arquivamento</p>
            <span>{Dates.toDateBRL(benefit.updated_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
